import type { Mission } from '../missions.ts'

export const fmc: Mission = {
  id: "fmc",
  name: "Federal Maritime Commission",
  short: "FMC",
  call: "Shipping",
  kind: "independent",
  url: "https://www.fmc.gov/",
  established: 1961,
  palette: {
    primary: "#0054a4",
    secondary: "#00a4e3",
    accent: "#c4a006",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Federal_Maritime_Commission_seal.svg",
  },
  motif: "anchor",
  mission: {
    text: "Our mission is to ensure a competitive and reliable international ocean transportation supply system that supports the U.S. economy and protects the public from unfair and deceptive practices.",
    url: "https://www.fmc.gov/about/",
  },
  fact: {
    text: "The FMC was officially established in 1961, but its genesis can be traced back to the turmoil of World War I.",
    url: "https://www.fmc.gov/about/",
  },
  seal: {
    file: "public/seals/fmc.png",
    source: "https://commons.wikimedia.org/wiki/File:Federal_Maritime_Commission_seal.svg",
  },
  identifier: {
    about: "https://www.fmc.gov/about/",
    accessibility: "https://www.fmc.gov/site-policies/accessibility-notice/",
    foia: "https://www.fmc.gov/about/freedom-of-information-act-requests-reports/",
    noFear: "https://www.fmc.gov/about/bureaus-offices/office-of-equal-employment-opportunity-oeeo/equal-employment-opportunity-rights-statistics/no-fear-act-statistics/",
    oig: "https://www.fmc.gov/about/bureaus-offices/inspector-general/",
    performance: "https://www.fmc.gov/about/strategies-budgets-and-performance/",
    privacy: "https://www.fmc.gov/site-policies/privacy-security-notice/",
  },
  media: {
    photos: [
      {
        file: "/media/fmc-port-miami.jpg",
        small: "/media/fmc-port-miami-sm.jpg",
        alt: "Aerial view of the Port of Miami container terminal, with gantry cranes working container ships along a narrow island between turquoise channels.",
        title: "Port of Miami container port from the air",
        creator: "James R. Tourtellotte, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:Aerial_photograph_of_the_Port_of_Miami_Container_Port.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fmc-port-oakland.jpg",
        small: "/media/fmc-port-oakland-sm.jpg",
        alt: "Aerial view of the Port of Oakland, with a container ship at the berth beneath cranes and acres of stacked containers and rail yards behind.",
        title: "Port of Oakland from the air, California, November 29, 2010",
        creator: "Daniel Parks",
        source: "https://commons.wikimedia.org/wiki/File:Port_of_Oakland.jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
